import { render } from "./EmployeeDeleteButton.vue?vue&type=template&id=d76d237e"
import script from "./EmployeeDeleteButton.vue?vue&type=script&lang=ts"
export * from "./EmployeeDeleteButton.vue?vue&type=script&lang=ts"
script.render = render

export default script